<template>
  <div class="xin">
    <!-- tab 切换  -->
    <div class="switch">
      <el-tabs v-show="filter_cell">
        <!-- 过滤单元 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit") }}</span>
          <div class="main">
            <el-button
              @click="save1()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.Policy_unit1") }}</el-button
            >
            <el-alert
              :title="$t('logs.Policy_unit2')"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList"
                :row-class-name="tableRowClassName"
                v-loading="loading"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="80"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_UNIT_TYPE"
                  :label="$t('logs.Policy_unit3')"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="UNIT_NAME"
                  :label="$t('logs.Policy_unit4')"
                >
                </el-table-column>
                <el-table-column prop="REMARK" :label="$t('logs.Policy_unit5')">
                </el-table-column>
                <el-table-column
                  prop="SHOW_IS_AND"
                  :label="$t('logs.Policy_unit6')"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_NUM"
                  :label="$t('logs.Policy_unit7')"
                >
                </el-table-column>
                <el-table-column
                  prop="BY_USED"
                  :label="$t('logs.Policy_unit8')"
                >
                </el-table-column>
                <el-table-column
                  prop="CREATETIME"
                  :label="$t('logs.Policy_unit9')"
                >
                </el-table-column>
                <el-table-column
                  prop=""
                  :label="$t('table1.operation')"
                  width="180"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      :disabled="$root.jurisdiction.only_query == 0"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                    <!-- 编辑 -->

                    <el-button
                      :disabled="$root.jurisdiction.only_query == 0"
                      type="text"
                      size="small"
                      @click="unit_edit(scope.$index, scope.row)"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                    <!-- 单元设置 -->

                    <el-button
                      :disabled="$root.jurisdiction.only_query == 0"
                      type="text"
                      size="small"
                      @click="oplicy_cell(scope.$index, scope.row)"
                    >
                      {{ scope.row.SHOW_SET_UNIT }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu"
              v-drag="{ handle: '.pop_up_text_cert_domain' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_cert_domain">
                <span class="span_pad"></span> {{ $t("logs.Policy_unit1") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤组合名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="unit_name" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 备注说明 -->
                    {{ $t("logs.Policy_unit5") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="remark" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 类型 -->
                    {{ $t("logs.smtpIp6") }}:
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="unit_type"
                      placeholder=""
                      @change="change_unit_type"
                    >
                      <el-option
                        v-for="item in unit_type1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1" v-show="regex_is_and_hidden">
                  <!--单元内规则关系 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional9") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="regex_is_and">
                      <el-radio :label="0">
                        {{ $t("logs.Conditional3") }}</el-radio
                      >
                      <el-radio :label="1">{{
                        $t("logs.Conditional2")
                      }}</el-radio>
                      <el-radio :label="2">{{ $t("logs.Content5") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1" v-show="other_is_and_hidden">
                  <!--单元内规则关系 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional9") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="other_is_and">
                      <el-radio :label="0">
                        {{ $t("logs.Conditional3") }}</el-radio
                      >
                      <el-radio :label="1">{{
                        $t("logs.Conditional2")
                      }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1" v-if="urlcondition_hidden">
                  <!--url检查 预制条件检查 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional11") }}:
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="urlcondition"
                      placeholder=""
                      @change="urlcondition_hideen"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1" v-if="urlcondition_yes_hidden">
                  <!--url检查  预制条件检查  是  URL包含收件人-->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional10") }}:
                  </div>
                  <div
                    class="block block1"
                    style="display: flex; flex-direction: row"
                  >
                    <el-checkbox v-model="chkhasrcpt"></el-checkbox>
                    <el-input
                      v-model="urlmaxcn"
                      placeholder="0为不检查，最大为9"
                    ></el-input>
                  </div>
                </div>
                <div class="find1" v-if="urlcondition_hidden">
                  <!--URL黑名单检查 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional12") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="chkurldn" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1" v-if="urlcondition_hidden">
                  <!--URL解析IP检查 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional13") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="chkurlip" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_unit">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="save12">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu"></div>
            <div
              class="pop-up"
              v-show="tanchu_edit"
              v-drag="{ handle: '.pop_up_text_relay_domain_edit' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_relay_domain_edit">
                <span class="span_pad"></span>
                {{ $t("logs.Policy_unit1_edit") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤组合名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.unit_name_edit }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 备注说明 -->
                    {{ $t("logs.Policy_unit5") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="remark" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 类型 -->
                    {{ $t("logs.smtpIp6") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="unit_type" placeholder="" disabled>
                      <el-option
                        v-for="item in unit_type1"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1" v-show="regex_is_and_hidden">
                  <!--单元内规则关系 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional9") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="regex_is_and" disabled>
                      <el-radio :label="0">
                        {{ $t("logs.Conditional3") }}</el-radio
                      >
                      <el-radio :label="1">{{
                        $t("logs.Conditional2")
                      }}</el-radio>
                      <el-radio :label="2">{{ $t("logs.Content5") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1" v-show="other_is_and_hidden">
                  <!--单元内规则关系 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional9") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="other_is_and" disabled>
                      <el-radio :label="0">
                        {{ $t("logs.Conditional3") }}</el-radio
                      >
                      <el-radio :label="1">{{
                        $t("logs.Conditional2")
                      }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1" v-if="urlcondition_hidden">
                  <!--url检查 预制条件检查 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional11") }}:
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="urlcondition"
                      placeholder=""
                      @change="urlcondition_hideen"
                    >
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1" v-if="urlcondition_yes_hidden">
                  <!--url检查  预制条件检查  是  URL包含收件人-->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional10") }}:
                  </div>
                  <div
                    class="block block1"
                    style="display: flex; flex-direction: row"
                  >
                    <el-checkbox v-model="chkhasrcpt"></el-checkbox>
                    <el-input
                      v-model="urlmaxcn"
                      placeholder="0为不检查，最大为9"
                    ></el-input>
                  </div>
                </div>
                <div class="find1" v-if="urlcondition_hidden">
                  <!--URL黑名单检查 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional12") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="chkurldn" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1" v-if="urlcondition_hidden">
                  <!--URL解析IP检查 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Conditional13") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="chkurlip" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_unit_edit">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="unit_off">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_edit"></div>
          </div>
        </el-tab-pane>

        <!-- 过滤组合 -->
        <el-tab-pane label="" class="policy_comb">
          <span slot="label">{{ $t("logs.Policy_comb") }}</span>
          <div class="main" v-if="this.show_policy_comb == 1">
            <el-button
              @click="save2()"
              :disabled="$root.jurisdiction.only_query == 0"
              >{{ $t("logs.Policy_comb11") }}
            </el-button>
          </div>
          <div class="switch1">
            <div
              class="table table02 table_hover"
              v-if="this.show_policy_comb == 1"
            >
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList_2"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="44"
                >
                </el-table-column>
                <el-table-column
                  prop="COMB_NAME"
                  :label="$t('logs.Policy_comb1')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <el-popover
                      placement="bottom"
                      visible-arrow="false"
                      trigger="hover"
                    >
                      <el-button slot="reference" type="text" size="small">{{
                        scope.row.COMB_NAME
                      }}</el-button>
                      <div>
                        <!-- 删除-->
                        <el-button
                          :disabled="$root.jurisdiction.only_query == 0"
                          @click="handleClick2(scope.$index, scope.row)"
                          type="text"
                          size="small"
                        >
                          {{ $t("table1.delete") }}
                        </el-button>
                        <!-- 编辑-->
                        <el-button
                          :disabled="$root.jurisdiction.only_query == 0"
                          @click="edit_comb(scope.$index, scope.row)"
                          type="text"
                          size="small"
                        >
                          {{ $t("table1.ditt") }}
                        </el-button>
                      </div>
                    </el-popover>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="COMB_RULE"
                  :label="$t('logs.Policy_comb2')"
                  width="170"
                >
                  <template slot-scope="scope">
                    <span
                      v-for="(v, i) in isClick(scope.row.COMB_RULE)"
                      :key="i"
                      @click="rule_combine(v.bol, v.val, scope.row)"
                      >{{ v.val }}</span
                    >
                  </template>
                </el-table-column>
                <el-table-column
                  prop="COMB_REMARK"
                  :label="$t('logs.Policy_unit5')"
                  width="120"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_DIRECT"
                  :label="$t('logs.Policy_comb3')"
                  width="70"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_ACTION"
                  :label="$t('logs.Policy_comb4')"
                  width="92"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_ACTIVE"
                  :label="$t('logs.Policy_comb5')"
                  width="70"
                >
                  <template slot-scope="scope">
                    <span v-if="scope.row.ACTIVE == 0" style="color: #f00">{{
                      scope.row.SHOW_ACTIVE
                    }}</span>
                    <span v-else>{{ scope.row.SHOW_ACTIVE }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="SHOW_RUNONCENTER"
                  :label="$t('logs.Policy_comb6')"
                  width="60"
                  v-if="this.runoncenter_center == 1"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_CFGCHECK"
                  :label="$t('logs.Policy_comb7')"
                  width="80"
                  v-if="this.cfgcheck_check == 1"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_TYPE"
                  :label="$t('logs.Policy_comb8')"
                  width="90"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_EXPIRE"
                  :label="$t('logs.Policy_comb9')"
                  width="70"
                >
                </el-table-column>
                <el-table-column
                  prop="CREATETIME"
                  :label="$t('logs.Policy_unit9')"
                >
                </el-table-column>
              </el-table>
            </div>
            <!-- 添加 和编辑部分-->
            <div class="lie lie_add_role" v-if="this.add_policy_comb == 1">
              <div class="create_information" v-if="this.policy_edit_comb == 0">
                {{ $t("logs.Policy_comb11") }}
              </div>
              <div class="create_information" v-if="this.policy_edit_comb == 1">
                {{ $t("logs.Policy_comb11_edit") }}
              </div>

              <div class="find">
                <div class="find1">
                  <div class="find-text find-text_comb">
                    <!-- 过滤组合名称 -->

                    {{ $t("logs.Policy_comb1") }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-if="this.policy_edit_comb == 0"
                      v-model="comb_name"
                      placeholder="数字与字母的组合"
                    ></el-input>
                    <p
                      v-if="this.policy_edit_comb == 1"
                      style="
                        text-align: left;
                        color: #0e2c5e;
                        margin: 8px 0px;
                        border-bottom: 0;
                      "
                    >
                      {{ this.comb_name }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text find-text_comb">
                    <!-- 过滤组合规则 -->

                    {{ $t("logs.Policy_comb2") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="comb_rule" placeholder="" clearable></el-input>
                    <el-select
                      v-model="select_combrule"
                      clearable
                      placeholder
                      style="margin-left: 10px; width: 140px"
                      @change="add_comb_rule"
                    >
                      <el-option
                        v-for="item in select_combrule_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text find-text_comb">
                    <!-- 备注说明 -->

                    {{ $t("logs.Policy_unit5") }} :
                  </div>
                  <div class="block block1">
                    <el-input v-model="remark" placeholder="" clearable></el-input>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text find-text_comb">
                    <!-- 策略类型 -->

                    {{ $t("logs.Policy_list13") }} :
                  </div>
                  <div class="block block1">
                    <el-select v-model="policy_type" placeholder="请选择">
                      <el-option
                        v-for="item in policy_type_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text find-text_comb">
                    <!-- 过滤动作 -->

                    {{ $t("logs.Policy_list6") }} :
                  </div>
                  <div class="block block1">
                    <el-select
                      v-model="comb_action"
                      placeholder="请选择"
                      @change="change_action"
                    >
                      <el-option
                        v-for="item in comb_action_arr"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="find1" v-if="this.has_fwd == true">
                  <div class="find-text find-text_comb">
                    <!-- 转发-->
                    {{ this.fwd_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_fwd"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>
                <div class="find1" v-if="this.has_cc == true">
                  <div class="find-text find-text_comb">
                    <!-- 抄送地址-->
                    {{ this.cc_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_cc"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>

                <div class="find1" v-if="this.has_defer == true">
                  <div class="find-text find-text_comb">
                    <!-- 延迟投递时间-->
                    {{ this.defer_time1 }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="defer_time"
                      :placeholder="this.alert_rate_minute"
                    ></el-input>
                  </div>
                </div>
                <div class="find1" v-if="this.has_notify == true">
                  <div class="find-text find-text_comb">
                    <!-- 通知地址-->
                    {{ this.notify_email }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_nto"
                      :placeholder="this.multi_address_hint"
                    ></el-input>
                  </div>
                </div>
                <div class="find1" v-if="this.has_addsub == true">
                  <div class="find-text find-text_comb">
                    <!-- 标题前缀-->
                    {{ this.subflag }} :
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="policy_addsub"
                      :placeholder="this.addsub_hint"
                    ></el-input>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text find-text_comb">
                    <!-- 启用策略到期日期 -->

                    {{ $t("logs.Policy_comb9") }} :
                  </div>

                  <div
                    class="block block1"
                    style="display: flex; align-items: center"
                  >
                    <el-checkbox
                      v-model="chkexpire"
                      style="margin-right: 10px"
                    ></el-checkbox>
                    <el-date-picker
                      v-model="expire"
                      type="date"
                      placeholder="选择日期"
                      style="padding-right: 0px"
                      :picker-options="pickerOptions"
                    >
                    </el-date-picker>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text find-text_comb">
                    <!-- 激活 -->

                    {{ $t("logs.Policy_comb5") }} :
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="active">
                      <el-radio :label="1">
                        {{ $t("logs.Policy_comb12") }}</el-radio
                      >
                      <el-radio :label="0">
                        {{ $t("logs.Policy_comb13") }}</el-radio
                      >
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1" v-if="this.runoncenter_center == 1">
                  <div class="find-text find-text_comb">
                    <!-- 中心节点运行 -->
                    {{ $t("logs.Policy_list10") }} :
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="runoncenter">
                      <el-radio :label="1">
                        {{ $t("logs.Policy_comb12") }}</el-radio
                      >
                      <el-radio :label="0">
                        {{ $t("logs.Policy_comb13") }}</el-radio
                      >
                    </el-radio-group>
                  </div>
                </div>

                <div class="find1" v-if="this.cfgcheck_check == 1">
                  <div class="find-text find-text_comb">
                    <!-- 允许设置不检查 -->
                    {{ $t("logs.Policy_list12") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="cfgcheck">
                      <el-radio :label="1">
                        {{ $t("logs.Policy_comb12") }}</el-radio
                      >
                      <el-radio :label="0">
                        {{ $t("logs.Policy_comb13") }}</el-radio
                      >
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text find-text_comb">
                    <!-- 方向 -->
                    {{ $t("logs.Policy_list8") }} :
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="direct">
                      <el-radio :label="1">{{
                        $t("logs.group7_a11")
                      }}</el-radio>
                      <el-radio :label="2">{{
                        $t("logs.group7_a12")
                      }}</el-radio>
                      <el-radio :label="3">{{ $t("logs.group7_a8") }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px"></div>
                  <div class="block block1" v-if="this.policy_edit_comb == 0">
                    <el-button type="primary" @click="save_comb" :disabled="$root.jurisdiction.only_query == 0">{{
                      $t("tab.save")
                    }}</el-button>
                    <el-button type="danger" @click="tanOff">{{
                      $t("tab.cancel")
                    }}</el-button>
                  </div>
                  <div class="block block1" v-if="this.policy_edit_comb == 1">
                    <el-button type="primary" @click="save_comb1" :disabled="$root.jurisdiction.only_query == 0">{{
                      $t("tab.save")
                    }}</el-button>
                    <el-button type="danger" @click="tanOff1">{{
                      $t("tab.cancel")
                    }}</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- 正则表达式测试 -->
        <el-tab-pane label="">
          <span slot="label">{{ $t("logs.Regex_test") }}</span>
          <div class="lie">
            <table>
              <tbody>
                <tr>
                  <!-- 输入文本 -->

                  <td>{{ $t("logs.Regex_test1") }}:</td>

                  <td style="width: 75%">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 10, maxRows: 21 }"
                      placeholder=""
                      v-model="test_value"
                      clearable
                    >
                    </el-input>
                  </td>
                </tr>
                <tr>
                  <!-- 正则表达式 -->

                  <td>{{ $t("logs.Regex_test2") }}:</td>

                  <td
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      width: 76%;
                    "
                  >
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder=""
                      v-model="regular"
                      clearable
                    >
                    </el-input>

                    <el-button
                      type="primary"
                      style="height: 30px; margin-left: 20px"
                      @click="pcre_test"
                      :disabled="$root.jurisdiction.only_query == 0"
                      >{{ $t("logs.Regex_test4") }}</el-button
                    >
                    <el-button
                      type="danger"
                      @click="cancel_del()"
                      style="height: 30px"
                      >{{ $t("tab.cancel") }}</el-button
                    >
                  </td>
                </tr>

                <tr>
                  <!-- 匹配结果 -->

                  <td>{{ $t("logs.Regex_test3") }}:</td>
                  <td style="width: 75%">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 10, maxRows: 21 }"
                      placeholder=""
                      v-model="readonly"
                    >
                    </el-input>
                  </td>
                </tr>
                <!--  <tr>
                                <td></td>
                                <td style="display:flex;flex-direction:row">
                                    <el-button type="primary" @click="tanSend()">保存</el-button>
                                    <el-button type="danger" @click="tanSend()">取消</el-button>
                                </td>
                            </tr>-->
              </tbody>
            </table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <!-- 发件人 -->
      <el-tabs v-show="tanchu_sender_all" v-loading="loading">
        <!-- 发件人 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_sender1") }}</span>
          <div class="main">
            <el-button @click="save_sender_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>
            <el-button @click="save_sender_show()">{{
              $t("logs.Policy_unit_sender2")
            }}</el-button>
             <el-button @click="daoru()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.to_envfrom_sender") }}</el-button>
                        <!-- 导出发件人白名单 -->

                        <el-button @click="export_to_sender()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.export_envfrom_sender") }}</el-button>
            <el-alert
              :title="this.show_hint"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="UNIT_NAME"
                  :label="$t('logs.Policy_unit4')"
                >
                </el-table-column>
                <el-table-column
                  prop="DNOREMAIL"
                  :label="$t('logs.Policy_unit_sender5')"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_TYPE"
                  :label="$t('logs.Policy_unit_sender6')"
                >
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_sender(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- 添加发件人 -->
            <div
              class="pop-up"
              v-show="tanchu_sender"
              v-drag="{ handle: '.pop_up_text_addfrom' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_addfrom">
                <span class="span_pad"></span>
                {{ $t("logs.Policy_unit_sender2") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 域名或邮箱账号 -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="users_sender"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_sender">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_sender">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_sender"></div>
                  <!-- 导入发件人白名单 -->
           <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_import_fromw' }"
            >
              <div class="pop_up_text  pop_up_text_import_fromw">
                <span style="padding:0 14px"></span>{{ $t("logs.to_envfrom_sender") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading_from_user_white">
                            <div class="find1">
                                <!-- ip地址-->

                                <div class="find-text" style="padding-right:12px">

                                </div>
                                <div class="block block1">
                                    <input type="file" @change="inputFileChange" id="iupfile_fromw"  class="iupfile" ref="clearFile" accept=".txt" />
                                </div>
                            </div>

                        </div>
                        <el-row>
                            <el-button type="primary" size="mini" @click="save_unit_to_list">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="save_to_sender()">{{$t('tan.cancel')}}</el-button>
                        </el-row>

                    </div>
                    <div class="gray" v-show="tanchu"></div>

          </div>
        </el-tab-pane>
        <!-- 发件人 -->
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- 收件人 -->
      <el-tabs v-show="tanchu_reciplent_all" v-loading="loading">
        <!-- 收件人 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_Recipient1") }}</span>
          <div class="main">
            <el-button @click="save_reciplent_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>
            <el-button @click="save_reciplent_show()">{{
              $t("logs.Policy_unit_Recipient2")
            }}</el-button>
             <el-button @click="daoru_from()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.to_envfrom_rec") }}</el-button>
                        <!-- 导出发件人白名单 -->

                        <el-button @click="export_from_sender()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.export_envfrom_rec") }}</el-button>
            <el-alert
              :title="this.show_hint"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="UNIT_NAME"
                  :label="$t('logs.Policy_unit4')"
                >
                </el-table-column>
                <el-table-column
                  prop="DNOREMAIL"
                  :label="$t('logs.Policy_unit_sender5')"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_TYPE"
                  :label="$t('logs.Policy_unit_sender6')"
                >
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_sender(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu_reciplent"
              v-drag="{ handle: '.pop_up_text_addrec' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_addrec">
                <span class="span_pad"></span>
                {{ $t("logs.Policy_unit_Recipient2") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 域名或邮箱账号 -->
                    {{ $t("logs.notify7") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="users_reciplent"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_reciplent">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_reciplent">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_reciplent"></div>
                 <!-- 导入发件人白名单 -->
           <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_url_wrc' }"
            >
              <div class="pop_up_text  pop_up_text_url_wrc">
                <span style="padding:0 14px"></span>{{ $t("logs.to_envfrom_rec") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading_from_user_white">
                            <div class="find1">
                                <!-- ip地址-->

                                <div class="find-text" style="padding-right:12px">

                                </div>
                                <div class="block block1">
                                    <input type="file" @change="inputFileChange" id="iupfile_fromrec"  class="iupfile" ref="clearFile" accept=".txt" />
                                </div>
                            </div>

                        </div>
                        <el-row>
                            <el-button type="primary" size="mini" @click="save_unit_from_list">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="save_to_sender()">{{$t('tan.cancel')}}</el-button>
                        </el-row>

                    </div>
                    <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- ip地址 -->
      <el-tabs v-show="tanchu_ip_all" v-loading="loading">
        <!-- ip地址 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_ip1") }}</span>
          <div class="main">
            <el-button @click="save_ip_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>
            <el-button @click="save_ip_show()">{{
              $t("logs.Policy_unit_ip2")
            }}</el-button>
               <el-button @click="daoru_ip()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.to_envfrom_ip") }}</el-button>
                        <!-- 导出发件人白名单 -->

                        <el-button @click="export_ip_sender()" :disabled="$root.jurisdiction.only_query==0">{{ $t("logs.export_envfrom_ip") }}</el-button>
            <el-alert
              :title="this.show_hint"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="UNIT_NAME"
                  :label="$t('logs.Policy_unit4')"
                >
                </el-table-column>
                <el-table-column
                  prop="DNOREMAIL"
                  :label="$t('logs.Policy_unit_sender5')"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_TYPE"
                  :label="$t('logs.Policy_unit_sender6')"
                >
                </el-table-column>
                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_sender(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu_ip"
              v-drag="{ handle: '.pop_up_text_addip' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_addip">
                <span class="span_pad"></span> {{ $t("logs.Policy_unit_ip2") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- ip地址 -->
                    {{ $t("logs.Policy_unit_ip1") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="users_ip"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_ip">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_ip">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_ip"></div>
                      <!-- 导入发件人白名单 -->
           <div class="pop-up" v-show="tanchu" v-drag="{ handle: '.pop_up_text_ipcor' }"
            >
              <div class="pop_up_text  pop_up_text_ipcor">
                <span style="padding:0 14px"></span>{{ $t("logs.to_envfrom_ip") }}
              </div>
              <p></p>
                        <div class="find" v-loading="loading_from_user_white">
                            <div class="find1">
                                <!-- ip地址-->

                                <div class="find-text" style="padding-right:12px">

                                </div>
                                <div class="block block1">
                                    <input type="file" @change="inputFileChange" id="iupfile_fromip"  class="iupfile" ref="clearFile" accept=".txt" />
                                </div>
                            </div>

                        </div>
                        <el-row>
                            <el-button type="primary" size="mini" @click="save_unit_ip_list">{{$t('tan.up')}}</el-button>
                            <el-button type="danger" @click="save_to_sender()">{{$t('tan.cancel')}}</el-button>
                        </el-row>

                    </div>
                    <div class="gray" v-show="tanchu"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- regex -->
      <el-tabs v-show="tanchu_regex_all" v-loading="loading">
        <!-- regex -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_regex1") }}</span>
          <div class="main">
            <el-button @click="save_regex_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>
            <el-button @click="save_regex_show()">{{
              $t("logs.Policy_unit_regex2")
            }}</el-button>
            <el-alert
              :title="this.show_hint"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="switch1">
            <div class="table table01">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList2"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="UNIT_NAME"
                  :label="$t('logs.Policy_unit4')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_TYPE"
                  :label="$t('logs.Policy_unit_regex3')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="HEADER_KEY"
                  :label="$t('logs.Policy_unit_regex4')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="UNIT_REGEX"
                  :label="$t('logs.Policy_unit_regex5')"
                >
                </el-table-column>
                <el-table-column
                  prop="SHOW_ISWORD"
                  :label="$t('logs.Policy_unit_regex6')"
                  width="140"
                >
                </el-table-column>
                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="140"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_regex(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                    <!-- 编辑 -->

                    <el-button
                      type="text"
                      size="small"
                      @click="unit_edit_regex(scope.$index, scope.row)"
                      >{{ $t("table1.ditt") }}</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu_regex"
              v-drag="{ handle: '.pop_up_text_addregex' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_addregex">
                <span class="span_pad"></span>
                {{ $t("logs.Policy_unit_regex2") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!--过滤单元名称 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <!--类型 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("anti_gs1.User_type") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="regex_type" @change="changyin01">
                      <el-option
                        v-for="item in regex_typee"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="find1" v-if="keyyin">
                  <!--信头key -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("anti_gs1.Headerkey") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="regex_header_key"
                      placeholder=""
                    ></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--过滤规则 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.group2") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="unit_regex" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--规则类型 -->

                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit_regex6") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="isword">
                      <el-radio :label="0">
                        {{ $t("logs.Regex_test2") }}</el-radio
                      >
                      <el-radio :label="1">{{
                        $t("logs.Regex_test5")
                      }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_regex">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_regex">取消</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_regex"></div>
            <div
              class="pop-up"
              v-show="tanchu_regex1"
              v-drag="{ handle: '.pop_up_text_addregex_edit' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_addregex_edit">
                <span class="span_pad"></span>
                {{ $t("logs.Policy_unit_regex2_edit") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <!--过滤单元名称 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>
                <div class="find1">
                  <!--类型 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("anti_gs1.User_type") }}:
                  </div>
                  <div class="block block1">
                    <el-select v-model="regex_type" @change="changyin01">
                      <el-option
                        v-for="item in regex_typee"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>

                <div class="find1" v-if="keyyin">
                  <!--信头key -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("anti_gs1.Headerkey") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      v-model="regex_header_key"
                      placeholder=""
                    ></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--过滤规则 -->
                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.group2") }}:
                  </div>
                  <div class="block block1">
                    <el-input v-model="unit_regex" placeholder=""></el-input>
                  </div>
                </div>
                <div class="find1">
                  <!--规则类型 -->

                  <div class="find-text" style="padding-right: 12px">
                    {{ $t("logs.Policy_unit_regex6") }}:
                  </div>
                  <div class="block block1">
                    <el-radio-group v-model="isword">
                      <el-radio :label="0">
                        {{ $t("logs.Regex_test2") }}</el-radio
                      >
                      <el-radio :label="1">{{
                        $t("logs.Regex_test5")
                      }}</el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_regex_edit">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_regex1">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_regex1"></div>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- rule-->
      <el-tabs v-show="tanchu_rule_all" v-loading="loading">
        <!-- regex -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_rule") }}</span>
          <div class="main">
            <el-button @click="save_rule_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>

            <el-alert
              :title="this.SHOW_RELATION1"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="main">
            <el-alert
              :title="this.SHOW_RELATION"
              type="warning"
              show-icon
              :closable="false"
            ></el-alert>
          </div>
          <div class="table ruel_find">
            <div class="find">
              <!--邮件尺寸-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_msgsize") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxmsgsize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="maxmsgsizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_msgsize") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minmsgsize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="minmsgsizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--正文尺寸-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bodysize") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxbodysize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="maxbodysizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bodysize") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minbodysize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="minbodysizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--附件尺寸-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_attsize") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxattsize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="maxattsizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_attsize") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minattsize"
                    style="width: 15%; margin-right: 8px"
                  >
                  </el-input>
                  <el-select v-model="minattsizeunit" style="width: 40%">
                    <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--附件数量-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_attnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxattnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_attnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minattnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--收件人数量-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_rcptnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_rcptnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--外部收件人数-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bsrcptnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxoutrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bsrcptnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minoutrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--大站点收件人数-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_outrcptnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxbsrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_outrcptnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minbsrcptnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--暗送收件人数-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bccnum") }}&lt;
                  </span>
                  <el-input
                    type="text"
                    v-model="maxbccnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_bccnum") }}&gt;=
                  </span>
                  <el-input
                    type="text"
                    v-model="minbccnum"
                    style="width: 57%"
                    class="ruel_find_input"
                  >
                  </el-input>
                </div>
              </div>
              <!--白名单检查-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_Checkwhite") }}:
                  </span>
                  <el-select v-model="checkwl" style="width: 57%">
                    <el-option
                      v-for="item in checkwll"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_Checknettype") }}:
                  </span>
                  <el-select v-model="nettype" style="width: 57%">
                    <el-option
                      v-for="item in nettypee"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
              <!--时间范围-->
              <div class="find1">
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_Timerange") }}:
                  </span>
                  &gt;=
                  <el-input
                    type="text"
                    v-model="starttime"
                    style="width: 28%; margin-right: 1%"
                    class="ruel_find_input"
                    placeholder="0-23"
                  >
                  </el-input>
                  &lt;=
                  <el-input
                    type="text"
                    v-model="endtime"
                    style="width: 28%"
                    class="ruel_find_input"
                    placeholder="1-24"
                  >
                  </el-input>
                </div>
                <div class="block block1">
                  <span class="ruel_find_text"
                    >{{ $t("logs.Policy_unit_rule_Checkfrom") }}:
                  </span>
                  <el-select v-model="chknullfrom" style="width: 57%">
                    <el-option
                      v-for="item in chknullfromm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
              </div>
            </div>

            <el-row>
              <!-- 保存 -->

              <el-button type="primary" @click="save_rule">{{
                $t("tab.save")
              }}</el-button>
              <!-- 取消 -->

              <!-- <el-button type="danger" @click="save11">{{ $t("tab.cancel") }}</el-button>-->
            </el-row>
          </div>
        </el-tab-pane>
        <el-tab-pane label=""> </el-tab-pane>
      </el-tabs>
      <!-- url -->
      <el-tabs v-show="tanchu_url_all" v-loading="loading">
        <!-- url -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_url1") }}</span>
          <div class="main">
            <el-button @click="save_url1_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>
            <el-button @click="save_url1_show()">{{
              $t("logs.Policy_unit_url2")
            }}</el-button>
          </div>
          <div class="switch1">
            <div class="table tableurl">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList6"
                :row-class-name="tableRowClassName"
              >
                <el-table-column
                  prop="RECSEQ"
                  :label="$t('table1.order')"
                  width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="UNIT_NAME"
                  :label="$t('logs.Policy_unit4')"
                >
                </el-table-column>

                <el-table-column
                  prop="URLDN"
                  :label="$t('logs.Policy_unit_url1')"
                >
                </el-table-column>

                <el-table-column
                  prop="address"
                  :label="$t('table1.operation')"
                  width="100"
                >
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_url1(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu_url1"
              v-drag="{ handle: '.pop_up_text_url_adress' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_url_adress">
                <span class="span_pad"></span> {{ $t("logs.Policy_unit_url2") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!--url 地址 -->
                    {{ $t("logs.Policy_unit_url1") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="urls_ip"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_url1">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_url1">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_url1"></div>
          </div>
        </el-tab-pane>
        <!-- url解析 -->
        <el-tab-pane label="">
          <span slot="label"> {{ $t("logs.Policy_unit_url3") }}</span>
          <div class="main">
            <el-button @click="save_url1_hide()">{{
              $t("logs.Policy_back")
            }}</el-button>
            <el-button @click="save_url1_show()">{{
              $t("logs.Policy_unit_url4")
            }}</el-button>
          </div>
          <div class="switch1">
            <div class="table tableurl">
              <el-table
                ref="multipleTable"
                tooltip-effect="dark"
                style="width: 100%"
                :data="fileList7"
                :row-class-name="tableRowClassName"
              >
                <el-table-column prop="RECSEQ" :label="$t('table1.order')">
                </el-table-column>
                <el-table-column
                  prop="UNIT_NAME"
                  :label="$t('logs.Policy_unit4')"
                >
                </el-table-column>

                <el-table-column
                  prop="URLIP"
                  :label="$t('logs.Policy_unit_url3')"
                >
                </el-table-column>

                <el-table-column prop="address" :label="$t('table1.operation')">
                  <template slot-scope="scope">
                    <!-- 删除 -->

                    <el-button
                      @click="handleClick_url2(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >
                      {{ $t("table1.delete") }}
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div
              class="pop-up"
              v-show="tanchu_url1"
              v-drag="{ handle: '.pop_up_text_url_ip' }"
            >
              <!--  认证控制-->
              <div class="pop_up_text pop_up_text_url_ip">
                <span class="span_pad"></span> {{ $t("logs.Policy_unit_url4") }}
              </div>
              <p></p>
              <div class="find">
                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- 过滤单元名称 -->
                    {{ $t("logs.Policy_unit4") }}:
                  </div>
                  <div class="block block1">
                    <p style="text-align: left; color: #0e2c5e">
                      {{ this.username }}
                    </p>
                  </div>
                </div>

                <div class="find1">
                  <div class="find-text" style="padding-right: 12px">
                    <!-- url 解析 -->
                    {{ $t("logs.Policy_unit_url3") }}:
                  </div>
                  <div class="block block1">
                    <el-input
                      type="textarea"
                      :autosize="{ minRows: 4, maxRows: 8 }"
                      placeholder="一行一个地址"
                      v-model="urls_ip1"
                      style="margin: 8px 0"
                    >
                    </el-input>
                  </div>
                </div>
              </div>

              <el-row>
                <el-button type="primary" @click="save_url2">{{
                  $t("tab.save")
                }}</el-button>
                <el-button type="danger" @click="off_url1">{{
                  $t("tab.cancel")
                }}</el-button>
              </el-row>
            </div>
            <div class="gray" v-show="tanchu_url1"></div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
// import $ from "jquery";
export default {
  data() {
    return {
      // 只可以选择今天之前的日期
      pickerOptions: {
        disabledDate(time) {
          // var todayYear = new Date().getFullYear();
          // var todayMonth = new Date().getMonth();
          // var todayDay = new Date().getDate();
          // var todayTime = new Date(
          //   todayYear,
          //   todayMonth,
          //   todayDay,
          //   "23",
          //   "59",
          //   "59"
          // ).getTime(); // 毫秒

          // return time.getTime() < todayTime ;
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },
      show_policy_comb: 1,
      add_policy_comb: 0,
      alert_rate_minute: "",
      change_show: "",
      addsub_hint: "",
      multi_address_hint: "",
      subflag: "",
      policy_addsub: "",
      policy_nto: "",
      notify_email: "",
      defer_time: "",
      defer_time1: "",
      policy_cc: "",
      cc_email: "",
      fwd_email: "",
      policy_fwd: "",

      policy_type_arr: [],
      comb_action_arr: [],
      reciplent: "",
      // 是否检查判断

      cfgcheck_check: "",
      // 中心节点判断
      runoncenter_center: "",
      urls_ip: "",
      urls_ip1: "",
      SHOW_RELATION: "",
      SHOW_RELATION1: "",
      unit_regex1: "",
      isword: "",
      users_ip: "",
      users_reciplent: "",
      users_sender: "",
      regex_header_key: "",
      unit_regex: "",
      regex_type: "SUBJECT",
      regex_typee: [],

      filter_unit_name: "",
      keyyin: false,
      loading: false,
      show_hint: "",

      // username
      username: "",
      // 单元条件规则设置
      maxmsgsize: "",
      maxmsgsizeunit: "KB",
      minmsgsize: "",
      minmsgsizeunit: "KB",
      maxbodysize: "",
      maxbodysizeunit: "KB",
      minbodysize: "",
      minbodysizeunit: "KB",
      maxattsize: "",
      maxattsizeunit: "KB",
      minattsize: "",
      minattsizeunit: "KB",
      maxattnum: "",
      minattnum: "",
      maxrcptnum: "",
      minrcptnum: "",
      maxoutrcptnum: "",
      minoutrcptnum: "",
      maxbsrcptnum: "",
      minbsrcptnum: "",
      maxbccnum: "",
      minbccnum: "",
      checkwl: "",
      checkwll: [],
      nettype: "",
      nettypee: [],
      chknullfrom: "",
      chknullfromm: [],
      starttime: "",
      endtime: "",
      select_combrule: "",
      select_combrule_arr: [],
      serder_name: "",
      reciplent_name: "",
      ip_name: "",
      regex_name: "",
      url1_name: "",
      url2_name: "",
      dnoremail: "",
      other_is_and: "",
      regex_is_and: "",
      unit_name_edit: "",
      tanchu_edit: false,
      policy_edit_comb: 0,
      tanchu_sender: false,
      tanchu_sender_all: false,
      tanchu_reciplent: false,
      tanchu_reciplent_all: false,
      tanchu_ip: false,
      tanchu_ip_all: false,
      tanchu_regex: false,
      tanchu_regex1: false,
      tanchu_regex_all: false,
      tanchu_rule_all: false,
      // tanchu_rul_all: true,
      tanchu_url1: false,
      tanchu_url_all: false,
      filter_cell: true,
      // 发件人设置
      address_cell: false,
      // 收件人设置
      recipients_cell: false,
      // ip 地址设置
      ip_cell: false,
      // 过滤规则设置
      rule_cell: false,
      // 条件规则设置
      condition_cell: false,
      // 单元url
      url_cell: false,
      // 过滤单元
      unit_type: 1,
      unit_type1: [],
      unit_name: "",

      // 过滤组合
      comb_name: "",
      comb_rule: "",
      remark: "",
      direct: "",
      active: "",
      runoncenter: "",
      cfgcheck: "",
      policy_type: [],
      chkexpire: "",
      expire: "",
      comb_action: "",
      // 正则表达式
      readonly: "",
      regular: "",
      test_value: "",
      textarea: "",
      input: "",
      time: new Date(2020, 9, 10, 18, 40),
      value1: "",

      tableData: [
        {
          address: "44",
        },
      ],
      emali: "",
      value: "",
      checkList: [],
      tanchu: false,
      options: [],
      checked: "",
      fileList2: [],
      fileList_2: [],
      fileList3: [],
      fileList4: [],
      fileList5: [],
      fileList6: [],
      fileList7: [],
      fileList: [],
      radio: [],
      unit_type_hidden: true,
      urlcondition: 0,
      urlcondition_hidden: false,
      urlcondition_yes_hidden: false,
      regex_is_and_hidden: false,
      other_is_and_hidden: false,
      chkhasrcpt: "",
      chkurlip: 0,
      chkurldn: 0,
      urlmaxcn: "",
      options1: [
        {
          label: "KB",
          value: "KB",
        },
        {
          label: "MB",
          value: "MB",
        },
        {
          label: "B",
          value: "B",
        },
      ],
      has_fwd: false,
      has_cc: false,
      has_defer: false,
      has_notify: false,
      has_addsub: false,
      loading_from_user_white:false,
       files:[],
    };
  },
  mounted() {
    this.getFileList1();
    this.getFileList2_comb();
  },
  methods: {
       // 导出ip
     export_ip_sender() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_unit_address";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&unit_name=${this.username}&type=3&sid=${sid}`);
        },
      // 导出收件人
     export_from_sender() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_unit_address";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&unit_name=${this.username}&type=2&sid=${sid}`);
        },
    // 导出发件人
     export_to_sender() {
            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let __mode = "download_unit_address";
            // console.log(__mode);

            // let routeData = this.$router.resolve({ path: '/garbageVirus/load',query:{id:1,name:'vue'}});
            window.open(`/api/adm/cgi/aspam.cgi?__mode=${__mode}&unit_name=${this.username}&type=1&sid=${sid}`);
        },
         daoru() {
            // console.log('aa')
            this.tanchu = true;
            this.$refs.clearFile.value = '';  
         document.getElementById("iupfile_fromw").value=""
 
        },
          daoru_from() {
            // console.log('aa')
            this.tanchu = true;
            this.$refs.clearFile.value = '';  
         document.getElementById("iupfile_fromrec").value=""
 
        },
            daoru_ip() {
            // console.log('aa')
            this.tanchu = true;
            this.$refs.clearFile.value = '';  
         document.getElementById("iupfile_fromip").value=""
 
        },
        // 单元发件人白名单增加
        save_unit_ip_list() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
this.loading_ip_user_white=true;

                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_unit_ip");
                fd.append("sid", sid);
                fd.append("unit_name", this.username);
                fd.append("type", 3);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/aspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    console.log(res);
                        this.loading_from_user_white = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;


                        this.getFileList2();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        // console.log(this.files)

                        this.$message({
                            type: "success",
                            message: `${res.data.ret}`,
                        });
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.del3')}`,
                        // });
                    }
                   
                });
            }
        },
         // 单元收件人白名单增加
        save_unit_from_list() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
this.loading_from_user_white=true;

                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_unit_email");
                fd.append("sid", sid);
                fd.append("unit_name", this.username);
                fd.append("type", 2);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/aspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    console.log(res);
                        this.loading_from_user_white = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;


                        this.getFileList2();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        // console.log(this.files)

                        this.$message({
                            type: "success",
                            message: `${res.data.ret}`,
                        });
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.del3')}`,
                        // });
                    }
                   
                });
            }
        },
        // 单元发件人白名单增加
        save_unit_to_list() {

            let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
            // console.log(sid);

            let iupfile = this.files;
            // console.log(iupfile);
            // 判断是否有文件
            if (0 == this.files.length) {
                this.$message({
                    type: 'info',
                    message: '请选择要上传的文件'
                });
                return;
            } else {
this.loading_from_user_white=true;

                let fd = new FormData();
                fd.append("iupfile", iupfile);
                // for (var i = 0; i < this.files.length; i++) {
                //     fd.append('fileUpload', this.files[i]);
                // }
                fd.append("__mode", "upload_unit_email");
                fd.append("sid", sid);
                fd.append("unit_name", this.username);
                fd.append("type", 1);
                // console.log(fd);
                this.$axios({
                    method: "post",
                    url: "/api/adm/cgi/aspam.cgi",
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                    data: fd,
                }).then((res) => {
                    console.log(res);
                        this.loading_from_user_white = false;

                    if (!res.data.fmstatus) {
                        alert(res.data);
                    } else if (res.data.fmstatus.code == "1") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                    } else if (res.data.fmstatus.code == "2") {
                        alert(res.data.fmstatus.errmsg);
                        this.$refs.clearFile.value = ''; // 清空file文件

                       
                    } else if (res.data.fmstatus.code == "3") {
                        alert(res.data.fmstatus.errmsg);
                        this.$router.push({
                            name: "login",
                        });
                    } else {
                        this.tanchu = false;


                        this.getFileList2();
                        this.$refs.clearFile.value = ''; // 清空file文件
                        this.files = ''
                        // console.log(this.files)

                        this.$message({
                            type: "success",
                            message: `${res.data.ret}`,
                        });
                        // this.$message({
                        //     type: "success",
                        //     message: `${this.$t('anti_gs1_tan.del3')}`,
                        // });
                    }
                   
                });
            }
        },
     inputFileChange(e) {
           
            this.files = e.target.files[0];
            // console.log(this.files,'fangwei');
        },
          save_to_sender() {
            this.tanchu = false;
        },
    add_comb_rule(value) {
      console.log(value);
      this.comb_rule += value;
      console.log(this.comb_rule, "组合策略的值");
    },
    change_action(a) {
      console.log(a);
      if (a == "FWD") {
        this.has_fwd = true;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_addsub = false;
      } else if (a == "CC") {
        this.has_cc = true;
        this.has_fwd = false;

        this.has_defer = false;
        this.has_notify = false;
        this.has_addsub = false;
      } else if (a == "DEFER") {
        this.has_defer = true;
        this.has_fwd = false;
        this.has_cc = false;

        this.has_notify = false;
        this.has_addsub = false;
      } else if (a == "NOTIFYOTHER") {
        this.has_notify = true;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;

        this.has_addsub = false;
      } else if (a == "ADDSUB") {
        this.has_addsub = true;
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
      } else {
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_addsub = false;
      }
    },
    // 组合策略 判断
    rule_combine(val, val1, val2) {
      let polity = val1;
      let combine = val2.COMB_HASH[polity];
      this.username = val1;
      // console.log(this.username)
      // console.log(val2)
      // console.log(val2.COMB_HASH[polity], '第几个')
      if (combine == 1) {
        this.tanchu_sender_all = true;
        this.filter_cell = false;

        this.getFileList2();
      } else if (combine == 2) {
        this.tanchu_reciplent_all = true;
        this.filter_cell = false;
        this.getFileList2();
      } else if (combine == 3) {
        this.tanchu_ip_all = true;
        this.filter_cell = false;
        this.getFileList2();
      } else if (combine == 4) {
        this.tanchu_regex_all = true;
        this.filter_cell = false;
        this.getFileList3();
      } else if (combine == 5) {
        this.tanchu_rule_all = true;
        this.filter_cell = false;
        this.getFileList4();
      } else if (combine == 6) {
        this.tanchu_url_all = true;
        this.filter_cell = false;
        this.getFileList6();
        this.getFileList7();
      }
    },
    // 规则判断

    isClick(str) {
      if (!str) {
        return [];
      }
      let arr = [];
      let str1 = "";
      let bol = false;
      for (let i = 0; i < str.length; ++i) {
        if (/^[a-zA-Z0-9]$/.test(str[i])) {
          if (bol) {
            str1 += str[i];
          } else {
            bol = true;
            if (str1) {
              arr.push({
                bol: false,
                val: str1,
              });
              str1 = "";
              str1 += str[i];
            } else {
              str1 += str[i];
            }
          }
        } else {
          if (!bol) {
            str1 += str[i];
          } else {
            bol = false;
            if (str1) {
              arr.push({
                bol: true,
                val: str1,
              });
              str1 = "";
              str1 += str[i];
            } else {
              str1 += str[i];
            }
          }
        }
        if (i == str.length - 1) {
          if (bol) {
            arr.push({
              bol: true,
              val: str1,
            });
          } else {
            arr.push({
              bol: false,
              val: str1,
            });
          }
        }
      }
      return arr;
    },
    cancel_del() {
      (this.regular = ""), (this.test_value = ""), (this.readonly = "");
    },

    urlcondition_hideen(b) {
      console.log(b, "b");
      if (b == 1) {
        this.urlcondition_yes_hidden = true;
      } else {
        this.urlcondition_yes_hidden = false;
      }
    },
    changyin01(a) {
      // console.log(a);

      if (a == "HEADERS") {
        this.keyyin = true;
      } else {
        this.keyyin = false;
      }
    },
    change_unit_type(a) {
      console.log(a);

      if (a == 4) {
        (this.regex_is_and_hidden = true),
          (this.other_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.urlcondition_yes_hidden = false);
      } else if (a == 5) {
        (this.other_is_and_hidden = true),
          (this.regex_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.urlcondition_yes_hidden = false);
      } else if (a == "6") {
        // this.urlcondition = 0
        (this.urlcondition_hidden = true),
          (this.regex_is_and_hidden = false),
          (this.other_is_and_hidden = false);
      } else
        (this.regex_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.other_is_and_hidden = false),
          (this.urlcondition_yes_hidden = false);
    },
    edit_comb(index, scope) {
      console.log(scope);
      this.show_policy_comb = 0;
      this.add_policy_comb = 1;
      this.policy_edit_comb = 1;
      this.comb_name = scope.COMB_NAME;
      this.comb_rule = scope.COMB_RULE;
      this.remark = scope.COMB_REMARK;
      this.direct = scope.DIRECT;
      this.active = scope.ACTIVE;
      this.runoncenter = scope.RUNONCENTER;
      this.cfgcheck = scope.CFGCHECK;
      this.policy_type = scope.TYPE;
      this.chkexpire = scope.CHKEXPIRE == 0 ? false : true;
      this.expire = scope.EXPIRE;
      this.comb_action = scope.ACTION;
      this.policy_fwd = scope.FWD_EMAIL;

      (this.policy_cc = scope.CC_EMAIL),
        (this.defer_time = scope.DEFER_TIME),
        (this.policy_addsub = scope.SHOW_ADDSUB),
        (this.policy_nto = scope.NOTIFY_EMAIL),
        (this.change_show = scope.ACTION);
      if (this.change_show == "FWD") {
        this.has_fwd = true;
      } else if (this.change_show == "CC") {
        this.has_cc = true;
      } else if (this.change_show == "DEFER") {
        this.has_defer = true;
      } else if (this.change_show == "NOTIFYOTHER") {
        this.has_notify = true;
      } else if (this.change_show == "ADDSUB") {
        this.has_addsub = true;
      } else {
        this.has_fwd = false;
        this.has_cc = false;
        this.has_defer = false;
        this.has_notify = false;
        this.has_addsub = false;
      }
    },
    // 过滤单元编辑
    unit_edit_regex(index, scope) {
      console.log(scope);
      this.tanchu_regex1 = true;
      this.username = scope.UNIT_NAME;
      this.regex_type = scope.TYPE;
      this.unit_regex = scope.UNIT_REGEX;
      this.unit_regex1 = scope.UNIT_REGEX;
      this.isword = scope.ISWORD;
      this.regex_header_key = scope.HEADER_KEY;
      // this.changyin01()
      if (this.regex_type == "HEADERS") {
        this.keyyin = true;
      } else {
        this.keyyin = false;
      }

      // console.log(scope)
    },
    // 过滤组合编辑保存
    save_comb1() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_policy_comb",
        sid: sid,
        comb_action: this.comb_action,
        expire: this.expire,
        chkexpire: this.chkexpire == true ? 1 : 0,
        policy_type: this.policy_type,
        cfgcheck: this.cfgcheck,
        runoncenter: this.runoncenter,
        active: this.active,
        direct: this.direct,
        remark: this.remark,
        comb_rule: this.comb_rule,
        comb_name: this.comb_name,
        newadd: 0,
        policy_comb_fwd: this.policy_fwd,
        policy_comb_cc: this.policy_cc,
        defer_time: this.defer_time,
        policy_comb_addsub: this.policy_addsub,
        policy_comb_nto: this.policy_nto,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.show_policy_comb = 1;
          this.add_policy_comb = 0;
          this.loading = false;
          this.getFileList2_comb();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 过滤组合保存
    save_comb() {
      // this.loading = true;
      this.$save_hint_test();
      this.$disable_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_policy_comb",
        sid: sid,
        comb_action: this.comb_action,
        expire: this.expire,
        chkexpire: this.chkexpire == true ? 1 : 0,
        policy_type: this.policy_type,
        cfgcheck: this.cfgcheck,
        runoncenter: this.runoncenter,
        active: this.active,
        direct: this.direct,
        remark: this.remark,
        comb_rule: this.comb_rule,
        comb_name: this.comb_name,
        newadd: 1,
        policy_comb_fwd: this.policy_fwd,
        policy_comb_cc: this.policy_cc,
        defer_time: this.defer_time,
        policy_comb_addsub: this.policy_addsub,
        policy_comb_nto: this.policy_nto,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
this.$close_disable_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.add_policy_comb = 0;
          this.show_policy_comb = 1;

          this.tanchu_sender = false;
          this.loading = false;
          this.getFileList2_comb();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    //正则表达式测试保存
    pcre_test() {
      // this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      let str = this.$qs.stringify({
        __mode: "pcre_test",
        sid: sid,
        test_value: this.test_value,
        regular: this.regular,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.readonly = res.data.ret.RESULT;
          this.loading = false;
         
        }
      });
    },
    // 过滤组合加载
    getFileList2_comb() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_policy_comb",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            // alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.select_combrule_arr = res.data.ret.q_select_combrule;
            this.fileList_2 = res.data.ret.datalist;
            this.runoncenter_center = res.data.ret.RUN_ON_CENTER;
            this.cfgcheck_check = res.data.ret.CFGCHECK;
            this.policy_type_arr = res.data.ret.q_policy_type;
            this.comb_action_arr = res.data.ret.q_policy_action;
            this.cc_email = res.data.ret.cc_email;
            this.defer_time1 = res.data.ret.defer_time;
            this.fwd_email = res.data.ret.fwd_email;
            this.multi_address_hint = res.data.ret.multi_address_hint;
            this.policy_comb_explam = res.data.ret.policy_comb_explam;
            this.policy_comb_name_hint = res.data.ret.policy_comb_name_hint;
            this.disableatoffline = res.data.ret.disableatoffline;
            this.notify_email = res.data.ret.notify_email;
            this.subflag = res.data.ret.subflag;
            this.alert_rate_minute = res.data.ret.alert_rate_minute;
          }
        });
    },
    //  url编辑
    // 过滤单元删除
    handleClick_url2(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let unit_name = scope.UNIT_NAME;
          let str = this.$qs.stringify({
            __mode: "del_unit_urlip",
            sid: sid,
            unit_name: unit_name,
            urlip: scope.URLIP,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList7();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // url解析加载
    getFileList7() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_unit_urlip",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList7 = res.data.ret.datalist;

            // this.regex_typee = res.data.ret.q_regex_type
            this.loading = false;
          }
        });
    },
    //  url编辑
    // 过滤单元删除
    handleClick_url1(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let unit_name = scope.UNIT_NAME;
          let str = this.$qs.stringify({
            __mode: "del_unit_urldn",
            sid: sid,
            unit_name: unit_name,
            urldn: scope.URLDN,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList6();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // url加载
    getFileList6() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_unit_urldn",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList6 = res.data.ret.datalist;
            this.show_hint = res.data.ret.SHOW_HINT;
            // this.regex_typee = res.data.ret.q_regex_type
            this.loading = false;
          }
        });
    },
    // 条件规则保存
    save_rule() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
this.$save_hint_test();
      let str = this.$qs.stringify({
        __mode: "save_unit_other",
        sid: sid,

        minattsizeunit: this.minattsizeunit,
        maxattsizeunit: this.maxattsizeunit,
        minbodysizeunit: this.minbodysizeunit,
        maxbodysizeunit: this.maxbodysizeunit,
        minmsgsizeunit: this.minmsgsizeunit,
        maxmsgsizeunit: this.maxmsgsizeunit,
        unit_name: this.username,
        maxmsgsize: this.maxmsgsize,
        minmsgsize: this.minmsgsize,
        maxbodysize: this.maxbodysize,
        minbodysize: this.minbodysize,
        maxattsize: this.maxattsize,
        minattsize: this.minattsize,
        maxattnum: this.maxattnum,
        minattnum: this.minattnum,
        maxrcptnum: this.maxrcptnum,
        minrcptnum: this.minrcptnum,
        maxoutrcptnum: this.maxoutrcptnum,
        minoutrcptnum: this.minoutrcptnum,
        maxbsrcptnum: this.maxbsrcptnum,
        minbsrcptnum: this.minbsrcptnum,
        maxbccnum: this.maxbccnum,
        minbccnum: this.minbccnum,
        starttime: this.starttime,
        endtime: this.endtime,

        checkwl: this.checkwl,
        chknullfrom: this.chknullfrom,
        nettype: this.nettype,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList4();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // 条件规则加载
    getFileList4() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "edit_unit_other",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.maxmsgsizeunit = res.data.ret.MAXMSGUNIT;
            this.minmsgsizeunit = res.data.ret.MINMSGUNIT;
            this.maxbodysizeunit = res.data.ret.MAXBODYUNIT;
            this.minbodysizeunit = res.data.ret.MINBODYUNIT;
            this.maxattsizeunit = res.data.ret.MAXATTUNIT;
            this.minattsizeunit = res.data.ret.MINATTUNIT;
            this.show_hint = res.data.ret.SHOW_HINT;
            this.maxmsgsize = res.data.ret.MAXMSGSIZE;
            this.minmsgsize = res.data.ret.MINMSGSIZE;
            this.maxbodysize = res.data.ret.MAXBODYSIZE;
            this.minbodysize = res.data.ret.MINBODYSIZE;
            this.maxattsize = res.data.ret.MAXATTSIZE;
            this.minattsize = res.data.ret.MINATTSIZE;
            this.maxattnum = res.data.ret.MAXATTNUM;
            this.minattnum = res.data.ret.MINATTNUM;
            this.maxrcptnum = res.data.ret.MAXRCPTNUM;
            this.minrcptnum = res.data.ret.MINRCPTNUM;
            this.maxoutrcptnum = res.data.ret.MAXOUTRCPTNUM;
            this.minoutrcptnum = res.data.ret.MINOUTRCPTNUM;
            this.maxbsrcptnum = res.data.ret.MAXBSRCPTNUM;
            this.minbsrcptnum = res.data.ret.MINBSRCPTNUM;
            this.maxbccnum = res.data.ret.MAXBCCNUM;
            this.minbccnum = res.data.ret.MINBCCNUM;
            this.starttime = res.data.ret.STARTTIME;
            this.endtime = res.data.ret.ENDTIME;
            this.SHOW_RELATION1 = res.data.ret.SHOW_HINT;
            this.SHOW_RELATION = res.data.ret.SHOW_RELATION;
            this.checkwl = res.data.ret.CHECKWL;
            this.chknullfrom = res.data.ret.CHKNULLFROM;
            this.nettype = res.data.ret.NETTYPE;
            this.checkwll = res.data.ret.q_checkwl;
            this.nettypee = res.data.ret.q_nettype;
            this.chknullfromm = res.data.ret.q_chknullfrom;
            this.loading = false;
          }
        });
    },
    // 内容过滤加载
    getFileList3() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_unit_regex",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          // console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            this.show_hint = res.data.ret.SHOW_HINT;
            this.regex_typee = res.data.ret.q_regex_type;
            this.loading = false;
          }
        });
    },
    // regex 删除保存
    handleClick_regex(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let rule_id = scope.RULE_ID;

          let str = this.$qs.stringify({
            __mode: "del_unit_regex",
            sid: sid,
            rule_id: rule_id,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            // console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList3();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },

    // regex 添加保存
    save_regex() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
this.$save_hint_test();
      let str = this.$qs.stringify({
        __mode: "save_unit_regex",
        sid: sid,
        unit_name: this.username,
        users: this.users_sender,
        type: this.regex_type,
        unit_regex: this.unit_regex,
        isword: this.isword,
        newadd: 1,
        header_key: this.regex_header_key,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_regex = false;
          this.loading = false;
          this.getFileList3();
        }
      });
    },
    // 发件人加载
    getFileList2() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_unit_email",
            sid: sid,
            unit_name: this.username,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.fileList2 = res.data.ret.datalist;
            this.show_hint = res.data.ret.SHOW_HINT;
            // this.show_hint = '55'
            this.loading = false;
          }
        });
    },
    // 发件人保存
    save_sender() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
this.$save_hint_test();
      let str = this.$qs.stringify({
        __mode: "save_unit_email",
        sid: sid,
        unit_name: this.username,
        users: this.users_sender,
        type: 1,
        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_sender = false;
          this.loading = false;
          this.getFileList2();
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    // 收件人保存
    save_reciplent() {
      // this.loading = true;
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_unit_email",
        sid: sid,
        unit_name: this.username,
        users: this.users_reciplent,
        type: 2,
        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
        this.$close_hint_test();

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_reciplent = false;
          this.loading = false;
          this.getFileList2();
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    // ip保存
    save_ip() {
      // this.loading = true;
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_unit_ip",
        sid: sid,
        unit_name: this.username,
        addrs: this.users_ip,

        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_ip = false;
          this.loading = false;
          this.getFileList2();
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    // 发件人删除
    handleClick_sender(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let unit_name = scope.UNIT_NAME;
          let dnoremail = scope.DNOREMAIL;
          let type = scope.TYPE;
          let str = this.$qs.stringify({
            __mode: "del_unit_email",
            sid: sid,
            unit_name: unit_name,
            dnoremail: dnoremail,
            type: type,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList2();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 过滤单元加载
    getFileList1() {
      this.loading = true;

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // console.log(sid);

      this.$axios
        .get("/api/adm/cgi/newspam.cgi", {
          params: {
            __mode: "load_policy_unit",
            sid: sid,
          },
        })
        .then((res) => {
          console.log(res);

          if (!res) {
            this.loading = false;
          } else if (!res.data.fmstatus) {
            alert(res.data);
          } else if (res.data.fmstatus.code == "1") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "2") {
            alert(res.data.fmstatus.errmsg);
            this.loading = false;
          } else if (res.data.fmstatus.code == "3") {
            alert(res.data.fmstatus.errmsg);
            this.$router.push({
              name: "login",
            });
          } else {
            this.loading = false;
            this.fileList = res.data.ret.datalist;
            this.unit_type1 = res.data.ret.q_unit_type;
            this.options = res.data.ret.q_yes_no;
          }
        });
    },
    // 过滤单元保存
    save_unit() {
      // this.loading = true;
      this.$save_hint_test()

      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_policy_unit",
        sid: sid,
        unit_name: this.unit_name,
        remark: this.remark,
        unit_type: this.unit_type,
        regex_is_and: this.regex_is_and,
        other_is_and: this.other_is_and,
        urlcondition: this.urlcondition,
        chkurldn: this.chkurldn,
        chkurlip: this.chkurlip,
        chkhasrcpt: this.chkhasrcpt == true ? 1 : 0,
        urlmaxcn: this.urlmaxcn,
      });
      console.log(str);
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
                        this.$close_hint_test()

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {

          this.tanchu = false;

          this.loading = false;
          this.getFileList1();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });

      this.real_code = "";
      this.real_addr = "";
    },
    // 过滤单元 编辑保存修改
    save_unit_edit() {
     
      this.tanchu_edit = false;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      this.$save_hint_test();
      let str = this.$qs.stringify({
        __mode: "update_policy_unit",
        sid: sid,
        unit_name: this.unit_name_edit,
        remark: this.remark,
        unit_type: this.unit_type,
        regex_is_and: this.regex_is_and,
        other_is_and: this.other_is_and,
        urlcondition: this.urlcondition,
        chkurldn: this.chkurldn,
        chkurlip: this.chkurlip,
        chkhasrcpt: this.chkhasrcpt == true ? 1 : 0,
        urlmaxcn: this.urlmaxcn,
      });
      // console.log(str)
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
 this.$close_hint_test()
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.loading = false;
          this.getFileList1();
          this.$message({
            type: "success",
            message: `${this.$t("anti_gs1_tan.save_sueecss")}`,
          });
        }
      });
    },
    // regex编辑保存
    save_regex_edit() {
      // this.bxian1 = false
      // this.bxian = true
      // this.loading = true;
      this.tanchu_edit = false;
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
      // let unit_name = scope.UNIT_NAME
      // let unit_type = scope.UNIT_TYPE
      // let regex_is_and = scope.IS_AND
      let oldregex = this.unit_regex1;
      let str = this.$qs.stringify({
        __mode: "save_unit_regex",
        sid: sid,
        unit_name: this.username,
        users: this.users_sender,
        type: this.regex_type,
        oldregex: oldregex,
        unit_regex: this.unit_regex,
        isword: this.isword,
        newadd: 0,
        header_key: this.regex_header_key,
      });
      console.log(str, "555555555");
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        // console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          // alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu_regex1 = false;
          this.loading = false;
          this.getFileList3();
        }
      });
    },
    // 过滤单元编辑
    unit_edit(index, scope) {
      console.log(scope);
      this.tanchu_edit = true;
      this.unit_name_edit = scope.UNIT_NAME;
      this.unit_type = scope.UNIT_TYPE;
      this.remark = scope.REMARK;
      this.other_is_and = scope.IS_AND;
      this.regex_is_and = scope.IS_AND;
      this.chkurlip = scope.CHKURLIP;

      this.chkurldn = scope.CHKURLDN;
      this.chkhasrcpt = scope.CHKHASRCPT == 1 ? true : false;
      this.urlmaxcn = scope.URLMAXCN;
      this.urlcondition = scope.HAS_CONDITION;
      if (this.urlcondition == 1) {
        this.urlcondition_yes_hidden = true;
      } else {
        this.urlcondition_yes_hidden = false;
      }

      if (scope.UNIT_TYPE == 4) {
        (this.regex_is_and_hidden = true),
          (this.other_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.urlcondition_yes_hidden = false);
      } else if (scope.UNIT_TYPE == 5) {
        (this.other_is_and_hidden = true),
          (this.regex_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.urlcondition_yes_hidden = false);
      } else if (scope.UNIT_TYPE == "6") {
        // this.urlcondition = 0
        (this.urlcondition_hidden = true),
          (this.regex_is_and_hidden = false),
          (this.other_is_and_hidden = false);
      } else
        (this.regex_is_and_hidden = false),
          (this.urlcondition_hidden = false),
          (this.other_is_and_hidden = false),
          (this.urlcondition_yes_hidden = false);
      // console.log(scope)
    },
    // 组合过滤，删除
    handleClick2(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let comb_name = scope.COMB_NAME;
          let str = this.$qs.stringify({
            __mode: "del_policy_comb",
            sid: sid,
            comb_name: comb_name,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList2_comb();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 过滤单元删除
    handleClick1(index, scope) {
      // console.log(index, scope)
      this.$confirm(`${this.$t("anti_gs1_tan.del")}`, {
        confirmButtonText: `${this.$t("tan.confirm")}`,
        cancelButtonText: `${this.$t("tan.cancel")}`,
        type: "warning",
      })
        .then(() => {
          let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
          let unit_name = scope.UNIT_NAME;
          let str = this.$qs.stringify({
            __mode: "del_policy_unit",
            sid: sid,
            unit_name: unit_name,
          });

          this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
            console.log(res);

            if (!res.data.fmstatus) {
              alert(res.data);
            } else if (res.data.fmstatus.code == "1") {
              alert(res.data.fmstatus.errmsg);
            } else if (res.data.fmstatus.code == "2") {
              alert(res.data.fmstatus.errmsg);
              // this.getFileList();
            } else if (res.data.fmstatus.code == "3") {
              alert(res.data.fmstatus.errmsg);
              this.$router.push({
                name: "login",
              });
            } else {
              this.loading = false;
              this.getFileList1();
              this.$message({
                type: "success",
                message: `${this.$t("anti_gs1_tan.del1")}`,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: `${this.$t("anti_gs1_tan.del2")}`,
          });
        });
    },
    // 各行变色
    tableRowClassName({ rowIndex }) {
      // console.log(row,rowIndex)
      if (rowIndex % 2 == 1) {
        return "warning-row";
        // console.log(2222)
      } else if (rowIndex % 2 !== 1) {
        return "success-row";
      }
      return "";
    },
    // 显示
    tan: function () {
      this.tanchu = true;
    },
    // url1 解析保存
    save_url2() {
      // this.loading = true;
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;
this.$save_hint_test();
      let str = this.$qs.stringify({
        __mode: "save_unit_urlip",
        sid: sid,
        unit_name: this.username,
        urlips: this.urls_ip1,

        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        this.$close_hint_test();
        console.log(res);

        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_url1 = false;
          this.loading = false;
          this.getFileList7();
        }
      });
    },
    // url1编辑保存
    save_url1() {
      // this.loading = true;
      this.$save_hint_test();
      let sid = JSON.parse(sessionStorage.getItem("usermsg")).sid;

      let str = this.$qs.stringify({
        __mode: "save_unit_urldn",
        sid: sid,
        unit_name: this.username,
        urls: this.urls_ip,

        bulkadd: 1,
      });
      this.$axios.post("/api/adm/cgi/newspam.cgi", str).then((res) => {
        console.log(res);
this.$close_hint_test();
        if (!res.data.fmstatus) {
          alert(res.data);
        } else if (res.data.fmstatus.code == "1") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "2") {
          alert(res.data.fmstatus.errmsg);
          // this.getFileList5();
        } else if (res.data.fmstatus.code == "3") {
          alert(res.data.fmstatus.errmsg);
          this.$router.push({
            name: "login",
          });
        } else {
          this.tanchu = false;
          this.tanchu_url1 = false;
          this.loading = false;
          this.getFileList6();
        }
      });
    },
    // url1编辑
    off_url1() {
      this.tanchu_url1 = false;
    },

    // regex编辑
    off_regex() {
      this.tanchu_regex = false;
    },
    // regex编辑
    off_regex1() {
      this.tanchu_regex1 = false;
    },

    // ip编辑
    off_ip() {
      this.tanchu_ip = false;
    },

    // 发件人编辑
    off_reciplent() {
      this.tanchu_reciplent = false;
    },
    // 发件人编辑

    // 收件人编辑
    //   过滤单元各种设置
    oplicy_cell(index, scope) {
      console.log(scope);
      this.username = scope.UNIT_NAME;

      if (scope.UNIT_TYPE == 1) {
        this.tanchu_sender_all = true;
        this.filter_cell = false;
        this.getFileList2();
      } else if (scope.UNIT_TYPE == 2) {
        this.tanchu_reciplent_all = true;
        this.filter_cell = false;
        this.getFileList2();
      } else if (scope.UNIT_TYPE == 3) {
        this.tanchu_ip_all = true;
        this.filter_cell = false;
        this.getFileList2();
      } else if (scope.UNIT_TYPE == 4) {
        this.tanchu_regex_all = true;
        this.filter_cell = false;
        this.getFileList3();
      } else if (scope.UNIT_TYPE == 5) {
        this.tanchu_rule_all = true;
        this.filter_cell = false;
        this.getFileList4();
      } else if (scope.UNIT_TYPE == 6) {
        this.tanchu_url_all = true;
        this.filter_cell = false;
        this.getFileList6();
        this.getFileList7();
      }
    },
    off_sender() {
      this.tanchu_sender = false;
    },
    // 打开关闭
    tanSend: function () {
      this.tanchu = false;
    },
    tanOff: function () {
      this.add_policy_comb = 0;
      this.show_policy_comb = 1;
    },
    tanOff1: function () {
      this.add_policy_comb = 0;
      this.show_policy_comb = 1;
    },
    unit_off: function () {
      this.tanchu_edit = false;
    },
    save1() {
      this.tanchu = true;
      this.unit_name = "";
      this.remark = "";
      this.unit_type = 1;
      this.urlcondition = 0;
      this.chkhasrcpt = false;
      this.urlmaxcn = 0;
      this.chkurldn = 0;
      this.chkurlip = 0;
      this.other_is_and = 1;
      this.regex_is_and = 0;
      this.change_unit_type();
    },
    save_sender_show() {
      this.tanchu_sender = true;
      this.users_sender = "";
    },
    save_reciplent_show() {
      this.tanchu_reciplent = true;
      this.users_reciplent = "";
    },
    save_ip_show() {
      this.tanchu_ip = true;
      this.users_ip = "";
    },
    save_regex_show() {
      this.tanchu_regex = true;
      this.regex_type = "SUBJECT";
      this.unit_regex = "";
      this.isword = 0;
      this.regex_header_key = "";
      this.changyin01();
    },
    save_url1_show() {
      this.tanchu_url1 = true;
      this.urls_ip = "";
      this.urls_ip1 = "";
    },
    save_url2_show() {
      this.tanchu_url2 = true;
    },
    // 保存
    save11() {
      this.tanchu = false;
    },
    // 取消
    save12() {
      this.tanchu = false;
    },
    // 返回
    save_url1_hide() {
      this.tanchu_url_all = false;
      this.filter_cell = true;
    },
    // 返回
    save_sender_hide() {
      this.tanchu_sender_all = false;
      this.filter_cell = true;
    },
    // 返回tanchu_reciplent_all
    save_reciplent_hide() {
      this.tanchu_reciplent_all = false;
      this.filter_cell = true;
    },
    // 返回
    save_ip_hide() {
      this.tanchu_ip_all = false;
      this.filter_cell = true;
    },
    // 返回
    save_regex_hide() {
      this.tanchu_regex_all = false;
      this.filter_cell = true;
    },
    // 返回
    save_rule_hide() {
      this.tanchu_rule_all = false;
      this.filter_cell = true;
    },
    // 过滤组合
    // 增加过滤组合
    save2() {
      this.comb_name = "";
      this.comb_rule = "";
      this.remark = "";
      this.direct = 1;
      this.active = 1;
      this.runoncenter = 1;
      this.cfgcheck = 0;
      this.policy_type = 0;
      this.comb_action = "REJECT";
      this.add_policy_comb = 1;
      this.show_policy_comb = 0;
      this.has_fwd = false;
      this.has_cc = false;
      this.has_defer = false;
      this.has_notify = false;
      this.has_addsub = false;
      this.policy_addsub = "";
      this.policy_nto = "";
      this.defer_time = "";
      this.policy_cc = "";
      this.policy_fwd = "";
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../css/table.less";
@import "../../css/lie_td.less";
@import "../../css/pou_up.less";
@import "../../css/drag.less";
@import "../../css/lie_add_role.less";

.tableurl {
  /deep/ .has-gutter th:nth-child(2) {
    text-align: left;
  }

  /deep/ .el-table__row td:nth-child(2) {
    text-align: left;
  }
}

/deep/ .has-gutter th {
  text-align: center;
}

/deep/ .has-gutter th:nth-child(4) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(5) {
  text-align: left;
}

/deep/ .has-gutter th:nth-child(3) {
  text-align: left;
}

// 表格居中位置
/deep/ .el-table__row td {
  text-align: center;
}

/deep/ .el-table__row td:nth-child(4) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(5) {
  text-align: left;
}

/deep/ .el-table__row td:nth-child(3) {
  text-align: left;
}

.pop-up .el-checkbox:last-of-type {
  margin-right: 8px;
}

.ruel_find .find {
  width: 100%;
}

.ruel_find .block {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ruel_find_text {
  margin-right: 8px;
  color: #0e2c5e;
  width: 120px;
  text-align: right;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
}

.ruel_find {
  /deep/ .el-button {
    padding: 8px 16px;
    // margin-left: 10px;
    font-size: 12px;
    // background: #eceff4;
    margin-top: 14px;
    margin-right: 10px;
  }

  .el-button--primary {
    background: #006be7;
  }

  .el-button--danger {
    background: #f05f5f;
  }
}

.pop-up {
  .find-text {
    margin-right: 8px;
  }
}

.policy_comb .pop-up {
  position: fixed;
  // padding: 20px 0;
  width: 40%;
  // height: 62%;
  top: 12%;
  left: 30%;
  z-index: 101;
  display: flex;
  flex: 1;
  overflow: auto;
  flex-direction: column;
  align-items: center;
  background: white;

  border-radius: 4px;
  //   margin-left: -12.5%;
  //   margin-top: -14%;
}
// .pop-up1{
//     height: 64%;
// }
/deep/ .table_hover tr td:nth-child(3) :hover {
  cursor: pointer;
}
.find-text_comb {
  padding-right: 10px;
}
</style>
